import { render } from "./DropDownButton.vue?vue&type=template&id=35dc24a4"
import script from "./DropDownButton.vue?vue&type=script&lang=js"
export * from "./DropDownButton.vue?vue&type=script&lang=js"

import "./DropDownButton.vue?vue&type=style&index=0&id=35dc24a4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__